module.exports = __webpack_public_path__ + "img/auth-bg-2-light.ac074374.svg";